import React from 'react';
import './AdditionalInfo.css';

function AdditionalInfo() {
  return (
    <section className="additional-info-section">
      <div className="container">
        <div className="additional-info-content">
          <h2 className="additional-info-heading">Invertimos con visión, diversificamos con criterio</h2>
          <p className="additional-info-paragraph">
            Tabia Group es un holding empresarial independiente cuyo principal objetivo es la creación de valor a través de la inversión diversificada. Gestionamos nuestro capital con una visión estratégica a largo plazo, invirtiendo en sectores con alto potencial de crecimiento y capacidad de generar rentabilidades recurrentes.
          </p>
          <p className="additional-info-paragraph">
            Nuestra estrategia se basa en la diversificación inteligente del riesgo, destinando recursos a distintos ámbitos de actividad como el sector inmobiliario, tecnológico, hotelero y otros negocios estratégicos, tanto a nivel nacional como internacional. Esta estructura nos permite equilibrar ciclos económicos, aprovechar oportunidades transversales y construir carteras sólidas y resilientes.
          </p>
          <p className="additional-info-paragraph">
            En Tabia Group no invertimos de forma oportunista: analizamos, estructuramos y acompañamos cada inversión, participando activamente en su desarrollo y gestión. Nuestro enfoque combina disciplina financiera, conocimiento sectorial y una profunda comprensión del mercado, con el objetivo de maximizar el valor a largo plazo y proteger el capital invertido.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AdditionalInfo;
